import styled, { css } from "styled-components";
import { BTTO_PROFILE_COLORS, bettoFocusRing } from "../../shared/elements";

const variantStyles = {
	primary: css`
		background: ${BTTO_PROFILE_COLORS.primary};
		color: ${BTTO_PROFILE_COLORS.primaryText};
		border: none;

		&:hover:not(:disabled) {
			background: ${BTTO_PROFILE_COLORS.primaryDark};
			color: ${BTTO_PROFILE_COLORS.primaryText};
		}
	`,
	secondary: css`
		background: ${BTTO_PROFILE_COLORS.surfaceRaised};
		color: ${BTTO_PROFILE_COLORS.text};
		border: 1px solid ${BTTO_PROFILE_COLORS.border};

		&:hover:not(:disabled) {
			background: ${BTTO_PROFILE_COLORS.surfaceHover};
		}
	`,
	ghost: css`
		background: transparent;
		color: ${BTTO_PROFILE_COLORS.primary};
		border: none;

		&:hover:not(:disabled) {
			opacity: 0.85;
		}
	`,
};

export const ButtonRoot = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	min-height: 36px;
	padding: 0 16px;
	border-radius: 8px;
	font-size: 13px;
	font-weight: 600;
	line-height: 1;
	cursor: pointer;
	white-space: nowrap;
	transition:
		background 0.2s ease,
		opacity 0.2s ease,
		color 0.2s ease;
	${bettoFocusRing}

	${({ $variant }) => variantStyles[$variant] || variantStyles.primary}

	&:disabled {
		opacity: 0.45;
		cursor: not-allowed;
	}

	${({ $variant }) =>
		$variant === "secondary" &&
		css`
			&:disabled {
				opacity: 0.7;
				color: ${BTTO_PROFILE_COLORS.textMuted};
			}
		`}

	${({ $fullWidth }) =>
		$fullWidth &&
		css`
			width: 100%;
		`}

	${({ $size }) =>
		$size === "sm" &&
		css`
			min-height: 32px;
			padding: 0 12px;
			font-size: 12px;
		`}
`;
